import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

const IconHelmet = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M16 4C10.5 4 6.1 8.2 6 13.6H5C4.4 13.6 4 14 4 14.6V17c0 .6.4 1 1 1h22c.6 0 1-.4 1-1v-2.4c0-.6-.4-1-1-1h-1C25.9 8.2 21.5 4 16 4Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
    <line x1="16" y1="4" x2="16" y2="13.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="4" y1="21" x2="28" y2="21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <path d="M8 21L7 28H25L24 21" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
  </svg>
);

const IconCrane = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <line x1="10" y1="4" x2="10" y2="28" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="10" y1="8" x2="26" y2="8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="26" y1="8" x2="26" y2="14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="10" y1="8" x2="4" y2="14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <rect x="22" y="14" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="1.6"/>
    <line x1="6" y1="28" x2="14" y2="28" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="18" y1="8" x2="18" y2="20" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeDasharray="2 2"/>
  </svg>
);

const IconBuilding = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect x="6" y="4" width="20" height="24" rx="1" stroke="currentColor" strokeWidth="1.6"/>
    <rect x="10" y="8" width="4" height="4" rx="0.5" stroke="currentColor" strokeWidth="1.4"/>
    <rect x="18" y="8" width="4" height="4" rx="0.5" stroke="currentColor" strokeWidth="1.4"/>
    <rect x="10" y="16" width="4" height="4" rx="0.5" stroke="currentColor" strokeWidth="1.4"/>
    <rect x="18" y="16" width="4" height="4" rx="0.5" stroke="currentColor" strokeWidth="1.4"/>
    <rect x="13" y="22" width="6" height="6" rx="0.5" stroke="currentColor" strokeWidth="1.4"/>
  </svg>
);

const IconBriefcase = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect x="4" y="10" width="24" height="18" rx="2" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M12 10V8a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="4" y1="18" x2="28" y2="18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    <line x1="14" y1="18" x2="18" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const IconTools = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M10 6C7.2 6 5 8.2 5 11c0 1.2.4 2.3 1.1 3.2L16 24l-1.8 1.8a2 2 0 0 0 2.8 2.8L27 18.7a2 2 0 0 0-2.8-2.8L22.4 17.7 13.2 8.5A5 5 0 0 0 10 6Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/>
    <path d="M22 6l4 4-2 2-1.5-1.5L21 12l-2-2 1.5-1.5L19 7l2-1Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
  </svg>
);

const IconBlueprint = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect x="5" y="4" width="22" height="26" rx="1.5" stroke="currentColor" strokeWidth="1.6"/>
    <line x1="10" y1="10" x2="22" y2="10" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <line x1="10" y1="15" x2="22" y2="15" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <line x1="10" y1="20" x2="17" y2="20" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M20 22l4-4 2 2-4 4h-2v-2Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
  </svg>
);

const SERVICES = [
  {
    Icon: IconHelmet,
    title: 'Supervisión de Obra',
    desc: 'Control técnico y seguimiento integral de proyectos para garantizar calidad y cumplimiento.',
  },
  {
    Icon: IconCrane,
    title: 'Infraestructura Civil',
    desc: 'Desarrollo de obras viales, hidráulicas y de urbanización para el crecimiento sostenible.',
  },
  {
    Icon: IconBuilding,
    title: 'Edificaciones',
    desc: 'Construcción de proyectos residenciales, comerciales e institucionales con enfoque funcional y estético.',
  },
  {
    Icon: IconBriefcase,
    title: 'Proyectos Corporativos',
    desc: 'Soluciones constructivas para empresas que buscan calidad, eficiencia e imagen profesional.',
  },
  {
    Icon: IconTools,
    title: 'Remodelaciones y Adecuaciones',
    desc: 'Optimización y transformación de espacios existentes según las necesidades de cada cliente.',
  },
  {
    Icon: IconBlueprint,
    title: 'Diseño e Ingeniería',
    desc: 'Planificación técnica y desarrollo de proyectos con precisión, innovación y visión a futuro.',
  },
];

const Services = () => {
  const [revealed, setRevealed] = useState(false);
  const sectionRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setRevealed(true); observer.disconnect(); } },
      { root: null, threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const goToProjects = (e, category) => {
    e.preventDefault();
    navigate(`/proyectos?categoria=${encodeURIComponent(category)}`);
  };

  return (
    <section
      id="services"
      ref={sectionRef}
      className={`services ${revealed ? 'services--reveal' : ''}`}
    >
      <div className="container">
        <div className="services__layout">

          {/* Left: heading + description */}
          <div className="services__left">
            <h2 className="services__heading">
              <span className="services__heading-top">Áreas de</span>
              <em>Experiencia</em>
            </h2>
            <div className="services__divider" />
            <p className="services__desc">
              Nuestra experiencia nos permite adaptarnos a distintos tipos de proyectos y
              necesidades constructivas, desarrollando soluciones eficientes en infraestructura
              civil, edificaciones, supervisión técnica y obras corporativas, siempre con
              enfoque en calidad, planificación y correcta ejecución.
            </p>
          </div>

          {/* Right: 3×2 grid */}
          <div className="services__grid">
            {SERVICES.map(({ Icon, title, desc }) => (
              <div key={title} className="service-card">
                <div className="service-card__icon">
                  <Icon />
                </div>
                <h3 className="service-card__title">{title}</h3>
                <p className="service-card__desc">{desc}</p>
                <a
                  href={`/proyectos?categoria=${encodeURIComponent(title)}`}
                  className="service-card__link"
                  onClick={(e) => goToProjects(e, title)}
                >
                  Ver proyectos
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Services;
